<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Top Cities
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/reporting?activeTab=city"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove()"
        >
          Delete
        </DefaultButton>
      </div>
    </div>

    <div
      v-if="!loading && Object.keys(cities).length > 0 && !error"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td>
              <span>City</span>
            </td>
            <td>
              <span>Visits</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(visits, city) in cities"
            :key="city"
          >
            <td class="keyword">
              <span class="text-danger"><i class="fad fa-map-marker-alt xs-mr-5" /></span> {{ city }}
            </td>
            <td>
              {{ visits > 0 ? visits.toLocaleString() : 0 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="Object.keys(cities).length === 0 && !error"
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No Data
      </div>
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      cities: {},
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'trafficData',
      'preview',
      'trafficDataError',
    ]),
    ...mapState('user', ['user']),
  },
  watch: {
    trafficData: {
      handler() {
        this.setData();
      },
      deep: true
    },
    trafficDataError: {
      handler() {
        if (this.trafficDataError) {
          this.error = `
                        <i class="fa fa-btn fa-exclamation-triangle"></i>
                        <span>There's a problem with your account connection. </span>
                        <a href="/website/settings/${this.activeWebsite.hash_id}">Go to settings</a>
                    `;
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (this.trafficData?.tables?.cities?.data) {
      this.setData();
    }
  },
  methods: {
    setData() {
      if (this.activeWebsite.has_ga_connection) {
        this.cities = this.trafficData?.tables?.cities?.data?.data ?? {};
        this.loading = false;
      } else {
        this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Analytics.</span> ${this.user ? `<a href="/website/settings/${this.user.active_website.hash_id}">Go to settings</a>` : ''}`;
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>
td {
  width: 50%;
}

tr td:not(:first-of-type) {
  text-align: center;
}
</style>
